<!-- begin:: Header Topbar -->
<ng-container>
  <!--begin: User bar -->
  <kt-user-profile4></kt-user-profile4>
  <!--end: User bar -->
</ng-container>
<!-- end:: Header Topbar -->
